/**
 * Onboarding Slices Module
 *
 * Re-exports all onboarding slices and combines them
 */
import { combineReducers } from '@reduxjs/toolkit';

// Import reducers
import { configReducer, type ConfigState } from './configSlice';
import { searchReducer, type SearchState } from './searchSlice';
import { flowReducer, type FlowState } from './flowSlice';

// Re-export actions from config slice
export { resetConfigState } from './configSlice';

// Re-export actions from search slice
export { setSearchLoading, clearSuggestions, resetSearchState } from './searchSlice';

// Re-export actions from flow slice
export { setCurrentStep, goToNextStep, goToPreviousStep, resetFlowState } from './flowSlice';

// Re-export types
export type { ConfigState } from './configSlice';
export type { SearchState } from './searchSlice';
export type { FlowState } from './flowSlice';

// Combined state type
export interface OnboardingState {
  readonly config: ConfigState;
  readonly search: SearchState;
  readonly flow: FlowState;
}

// Combined reducer
export const onboardingReducer = combineReducers({
  config: configReducer,
  search: searchReducer,
  flow: flowReducer,
});
